if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form?.addEventListener("submit", this.onSubmitHandler.bind(this));
        // this.cart =
        //   document.querySelector("cart-notification") ||
        //   document.querySelector("cart-drawer-items");
        this.submitButton = this.querySelector('[type="submit"]');
        this.message = document.getElementById("promptMessage"); //添加成功
        this.masking = document.getElementById("masking"); //蒙版
        // this.isMobile = /Mobi|Android|iPhone/i.test(navigator.userAgent);
        this.product_id = this.form?.querySelector("[name=product-id]").value;
        if (document.querySelector("cart-drawer-items"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");
        this.hideErrors = this.dataset.hideErrors === "true";
        const userString = localStorage.getItem("user");
        this.loginFlag = theme.inspectJson(userString)?.loginFlag;
      }

      validatorProductForm() {
        let disableFlag = true;
        const quantityList = document.querySelectorAll(
          ".quantity.quantity-allff"
        );
        quantityList.forEach((item) => {
          if (!item.classList.contains("disabled")) {
            disableFlag = false;
          }
        });
        if (disableFlag) {
          const tips = document.querySelector(".add-tips");
          tips ? tips.classList.remove("hidden") : "";
          quantityList.forEach((item) => {
            item.classList.add("quantity-active");
          });
          setTimeout(() => {
            tips ? tips.classList.add("hidden") : "";
            quantityList.forEach((item) => {
              item.classList.remove("quantity-active");
            });
          }, 2000);
        }
        return disableFlag;
      }

      /**
       * 获取加购产品
       */
      getAddItems() {
        const items = [];
        $(this)
          .closest(".grid__item_wu")
          .find(".quantity-allff")
          .each(function () {
            const inputEle = $(this).find('input[name="quantity"]');
            const variantEle = this.querySelector('input[name="variant"]');
            const productEle = this.querySelector('input[name="product"]');
            const options = variantEle?.dataset?.name?.split("/");
            const imgSrc = variantEle?.dataset?.img;
            if (inputEle.val() > 0) {
              const quantity = parseInt(inputEle.val());
              const obj = {
                quantity: quantity,
                id: variantEle.value,
                variant_id: variantEle.value,
                checked: true,

                url: productEle?.dataset?.url,
                product_id: productEle.value,
                product_title: productEle?.dataset?.name,
                featured_image: { url: imgSrc },
                variant_options: options,
                final_price: variantEle?.dataset?.price,
                weight: variantEle?.dataset?.weight,
              };
              items.push(obj);
            }
          });
        return items;
      }

      /**
       * 加购成功后的处理
       */
      handleAddSuccess() {
        const quickAddModal = this.closest("quick-add-modal");
        if (quickAddModal) {
          quickAddModal.hide(true);
        }

        this.message.classList.remove("hidden");
        this.masking.classList.remove("hidden");
        this.submitButton.classList.remove("loading");
        this.querySelector(".loading-overlay__spinner")?.classList.add(
          "hidden"
        );
        this.form.reset();
        this.message.classList.add("show");
        var timer = setTimeout(() => {
          clearTimeout(timer);
          this.message.classList.remove("show");
          this.message.classList.add("hidden");
          this.masking.classList.add("hidden");
        }, 2000);

        this.masking.classList.remove("maskingShow");
        this.submitButton.classList.remove("loading");
        this.submitButton.removeAttribute("aria-disabled");
        $(this)
          .closest(".grid__item_wu")
          .find(".quantity-allff")
          .each(function () {
            $(this).find('input[name="quantity"]').val(0);
            this.classList.add("disabled");
          });
        const totalElment = document.querySelector(".total .total-items");
        const totalCountEle = document.querySelectorAll(".totalcount");
        if (totalCountEle) {
          totalCountEle.forEach(function (item) {
            item.style.display = "none";
          });
        }
        if (totalElment) {
          totalElment.innerHTML = 0;
        }
      }

      calculatePrice(list) {
        if (!list || list.length === 0) return 0;
        let total = 0;
        for (let item of list) {
          total += Number(item.final_price) * Number(item.quantity);
        }
        return Number((total / 100).toFixed(2));
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.validatorProductForm()) return;
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;
        this.handleErrorMessage();
        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this?.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden"
        );
        this.masking.classList.add("maskingShow");
        const adapter = new StorageAdapter();
        const shopify = new ShopifyRelatedV2();
        const localKey = "cartItems";
        const cartItems = this.getAddItems();
        const items = await adapter.create({
          key: localKey,
          value: cartItems,
        });
        if (items) {
          await this.handleAddSuccess();
          if (cartPop) {
            const list = [];
            items.forEach((item) => {
              const index = cartItems?.findIndex(
                (cartItem) => cartItem.variant_id == item.variant_id
              );
              if (index != -1) {
                list.push(item);
              }
            });
            cartPop.cartList = items;
            cartPop.shopifyCartData = await shopify.create(items);
            cartPop.handleDataList();
          }
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper?.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
